import React, { useEffect, useRef, useState } from 'react';
import { measureHeight } from 'react-div-100vh';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import { LogoSvg } from './Logo';
import thyroidBubble from '../../../static/thyroidBubble.png';
import { InputWithLabel } from '../../../components/TextInput';
import styled, { keyframes } from 'styled-components';
import Mailcheck from 'react-mailcheck';
import * as Yup from 'yup';
import { CURRENT_USER, DISQUALIFY_WEIGHTLOSS, EMAIL_AVAILABLE, QUALIFIES_WEIGHTLOSS } from '../../../graphql';
import withAnalytics from '../../../lib/withAnalytics';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { AddonCard } from '../../asyncIntake/screens/OtherCustomersFavourites';
import palomaKit from '../../../static/palomaKit.png';
import vitaminsBottle from '../../../static/vitaminsBottle.png';
import { Constants } from '../../../utils/constants';
import { isMobile } from 'react-device-detect';

import DocWithBubblesLg from '../../../static/DocWithBubblesLg.png';
import TirzepatideAd from '../../../static/TirzepatideAd.png';
import InsurancesPartners from '../../../static/InsurancesPartners.png';
import PatientReports from '../../../static/PatientReports.png';
import ThyroidGif from '../../../static/Thyroid.gif';
import { isPreviewMode } from '../../../utils/environments';

const MailcheckWrapper = styled.div`
  text-align: right;
  @media screen and (max-width: 52em) {
    text-align: left;
  }
`;

const MailcheckButton = styled(Button)`
  padding: 0;
  border: none;
  background: none;
  font-size: inherit;
  font-style: italic;
  color: rgb(237, 183, 168);
  cursor: pointer;
  text-decoration: underline;
  text-underline-position: under;

  &:focus {
    outline: none;
    color: rgb(237, 183, 168);
  }

  &:hover {
    color: rgb(237, 183, 168);
  }

  &:active {
    color: rgb(237, 183, 168);
  }
`;
let schema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
});

const EligibleWl = ({ onContinue, state, onChange, client, history, isLoggedInMode, analytics }) => {
  const emailRef = useRef();
  const [isValid, setIsValid] = useState();
  const [isChecking, setIsChecking] = useState(false);
  const handleEmailClick = () => {
    if (emailRef.current) {
      emailRef.current.focus();
    }
  };
  useEffect(() => {
    try {
      analytics.track('Weightloss Qualified');
    } catch (error) {}
    if (isLoggedInMode) {
      client.mutate({
        mutation: QUALIFIES_WEIGHTLOSS,
        refetchQueries: [{query: CURRENT_USER}],
        awaitRefetchQueries: true
      });
      onContinue();
    }
  }, []);

  const bubbleHeight = measureHeight() / 2;
  const bubbleWidth = window.innerWidth;

  const submitCheck = async () => {
    setIsChecking(true);
    try {
      const { data } = await client.query({
        query: EMAIL_AVAILABLE,
        variables: {
          email: state.email,
          klaviyoAdd: true,
        },
      });
      setIsChecking(false);
      if (!data.emailAvailable.ok) {
        if (!!data.emailAvailable.mobile) {
          history.push('/account-exists');
          return;
        }
        history.push('/account-already-exists');
        return;
      } else {
        onContinue();
      }
    } catch (error) {
      setIsChecking(false);
    }
  };

  useEffect(
    () => {
      schema
        .validate(state)
        .then((valid) => {
          // console.log(valid);
          setIsValid(true);
        })
        .catch((error) => {
          console.log(error);
          setIsValid(false);
        });
    },
    [state]
  );
  return (
    <Flex flex={1} style={{ background: '#1D3457', minWidth: '100vw', minHeight: '100vh', position: 'relative', overflow: isMobile ? 'auto' : 'hidden', flexDirection: 'column', marginTop: '-4px' }}>
      <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }} mt={4} flexDirection={'column'}>
        <LogoSvg />
        <Text style={{ fontSize: isMobile ? '22px' : '24px', fontWeight: 500, textAlign: 'center', color: 'white' }} mb={isMobile ? '70px' : '100px'} mt={isMobile ? '30px' : '67px'}>
          You’re eligible! Start your new weight loss journey!
        </Text>
      </Flex>
      <Flex flex={1} style={{ position: 'relative', flexDirection: 'column', backgroundColor: '#FDF5F2' }} pb={4}>
        <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center', zIndex: 1, marginTop: '30px' }} flexDirection={'column'}>
          <Text style={{ fontSize: isMobile ? '26px' : '30px', fontWeight: 600, textAlign: 'center', maxWidth: 'calc(100% * 0.75)' }} mb={isMobile ? '32px' : '44px'}>
            Let’s get started
          </Text>
          {!isLoggedInMode ? (
            <>
              <Text style={{ fontSize: isMobile ? '18px' : '24px', fontWeight: 500, textAlign: 'center' }} mb={isMobile ? '32px' : '44px'}>
                Enter your email to get started with Paloma
                <br />
                and schedule your first visit
              </Text>
              <Mailcheck email={state['email']}>
                {(suggestion) => (
                  <>
                    <Flex
                      flex={1}
                      flexDirection={'row'}
                      onClick={handleEmailClick}
                      style={{ border: `1px solid #909ebb`, borderRadius: '12px', padding: '12px 0px 0px 0px', background: 'white', cursor: 'pointer', alignItems: 'center', width: '300px' }}
                    >
                      <Flex flex={1} flexDirection={'column'}>
                        <InputWithLabel
                          style={{ border: 0, background: 'white', color: '#344f79' }}
                          subref={emailRef}
                          placeholder="Your Email Address"
                          type="text"
                          name="email"
                          value={state['email']}
                          onChange={(e) => {
                            onChange('email', e.target.value);
                          }}
                        />
                      </Flex>
                    </Flex>
                    {suggestion && (
                      <MailcheckWrapper className="mailcheck">
                        Did you mean{' '}
                        <MailcheckButton type="button" onClick={() => onChange('email', suggestion.full)}>
                          {suggestion.full}
                        </MailcheckButton>
                        ?
                      </MailcheckWrapper>
                    )}
                  </>
                )}
              </Mailcheck>
              {!!state['email'] && !isValid && <Text style={{ color: 'red' }}>Invalid Email Address</Text>}
              <Button variant={'pink'} mt={'44px'} style={{ paddingLeft: '140px', paddingRight: '140px' }} onClick={submitCheck} disabled={!state['email'] || !isValid || !!isChecking}>
                Submit
              </Button>
            </>
          ) : (
            <Button variant={'pink'} mt={'44px'} style={{ paddingLeft: '60px', paddingRight: '60px' }} onClick={onContinue}>
              Continue
            </Button>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

const EligibleHypo = ({ onContinue, analytics }) => {
  useEffect(() => {
    try {
      analytics.track('Not qualifying WL - Eligible Hypo');
    } catch (error) {}
  }, []);

  return (
    <Flex flex={1} style={{ background: '#1D3457', minWidth: '100vw', minHeight: '100vh', position: 'relative', overflow: isMobile ? 'auto' : 'hidden', flexDirection: 'column' }}>
      <Flex style={{ background: '#FDF5F2', justifyContent: 'center', alignItems: 'center' }}>
        <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }} mt={4} flexDirection={'column'}>
          <LogoSvg />
          <Text style={{ fontSize: '24px', fontWeight: 500, textAlign: 'center' }} mb={'100px'} mt={'67px'}>
            Based on your medical history, you do not qualify for our weight loss program but we have some options for you!
          </Text>
        </Flex>
      </Flex>
      <Flex flex={1} style={{ position: 'relative', flexDirection: 'column', backgroundColor: '#1D3457' }} pb={4}>
        <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center', zIndex: 1, marginTop: '30px' }} flexDirection={'column'}>
          <Text style={{ fontSize: '30px', fontWeight: 600, textAlign: 'center', color: 'white', maxWidth: 'calc(100% * 0.75)' }} mb={'44px'}>
            You're eligible to our specialized hypothyroid care
          </Text>
          <Text style={{ fontSize: '24px', fontWeight: 500, textAlign: 'center', color: 'white' }} mb={'44px'}>
            Get hypothyroid care from the best thyroid specialists
          </Text>
          <img src={thyroidBubble} />

          <Button variant={'pink'} mt={'44px'} style={{ paddingLeft: '60px', paddingRight: '60px' }} onClick={onContinue}>
            Sign Up
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

const EligibleMeno = ({ onContinue, analytics }) => {
  useEffect(() => {
    try {
      analytics.track('Not qualifying WL - Eligible Meno');
    } catch (error) {}
  }, []);

  return (
    <Flex flex={1} style={{ background: '#FDF5F2', minWidth: '100vw', minHeight: '100vh', position: 'relative', overflow: isMobile ? 'auto' : 'hidden', flexDirection: 'column' }}>
      <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }} mt={4} flexDirection={'column'}>
        <LogoSvg />
        <Text style={{ fontSize: '24px', fontWeight: 500, textAlign: 'center' }} mb={'100px'} mt={'67px'}>
          Based on your medical history, you do not qualify for our weight loss program but we have some options for you!
        </Text>
      </Flex>
      <Flex flex={1} style={{ position: 'relative', flexDirection: 'column', backgroundColor: '#1D3457' }} pb={4}>
        <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center', zIndex: 1, marginTop: '30px' }} flexDirection={'column'}>
          <Text style={{ fontSize: '30px', fontWeight: 600, textAlign: 'center', color: 'white', maxWidth: 'calc(100% * 0.75)' }} mb={'44px'}>
            Get Personalized Menopause Support
          </Text>
          <Text style={{ fontSize: '24px', fontWeight: 500, textAlign: 'center', color: 'white' }} mb={'44px'}>
            Get menopause and perimenopause from the best hormonal health specialists
          </Text>
          <svg width="133" height="117" viewBox="0 0 133 117" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M124.908 92.6275C119.484 99.3182 112.712 103.819 105.47 107.571C88.0191 116.615 69.6375 118.766 50.4604 114.754C46.5622 113.938 42.5792 113.508 38.6214 113.015C31.544 112.134 25.0277 109.805 19.7109 104.939C13.6603 99.402 9.32103 92.5812 6.38777 84.8995C0.65731 69.8895 -1.02352 54.5543 3.08074 38.8251C4.53371 33.2543 7.38064 28.3536 10.3232 23.459C14.6947 16.1841 20.6918 10.5488 27.3872 5.62336C31.527 2.57837 36.469 1.37966 41.4907 0.862699C61.0913 -1.15058 80.3356 0.657131 99.0707 6.91852C102.467 8.05384 106.087 9.39861 108.75 11.6682C112.662 15.1192 116.191 18.9884 119.275 23.2077C124.592 30.2511 127.497 38.474 129.329 47.0678C131.286 56.2469 132.896 65.4865 131.865 74.9335C131.143 81.5437 128.437 87.4055 124.908 92.6275Z"
              fill="#E7F0FF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M72.2237 28.0882C79.632 28.2985 87.8368 25.9286 93.44 30.8041C99.2466 35.8565 100.758 44.4626 99.8516 52.1278C99.0352 59.0308 93.9684 64.156 88.9318 68.9204C84.1073 73.4843 78.7725 79.2718 72.2237 78.2625C65.9157 77.2904 64.665 68.7868 59.9584 64.4551C54.7795 59.6887 45.8038 58.9001 43.827 52.1278C41.5616 44.3665 43.619 34.7753 49.7741 29.5646C55.7367 24.5169 64.4309 27.867 72.2237 28.0882Z"
              fill="#FFE3D8"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M62.8225 15.9576C58.2618 16.5845 54.291 18.1295 50.3704 20.803C48.1639 22.3075 44.6517 25.8937 43.1215 28.2047C35.4813 39.7437 37.007 54.7385 46.8019 64.3775C50.4997 68.0165 55.4567 70.6988 60.4407 71.7577L61.8196 72.0508V88.0956L59.02 88.1519C55.8712 88.2151 55.5379 88.3179 54.5666 89.5258L54.0475 90.1716V95.6539L54.5666 96.2996C55.5379 97.5076 55.8712 97.6104 59.02 97.6736L61.8196 97.7299V101.191C61.8196 105.19 61.9637 105.749 63.2066 106.576C63.8696 107.017 63.9422 107.027 66.4996 107.027C69.0571 107.027 69.1296 107.017 69.7927 106.576C71.0356 105.749 71.1796 105.19 71.1796 101.191V97.7299L73.9793 97.6736C77.1281 97.6104 77.4614 97.5076 78.4326 96.2996L78.9518 95.6539V90.1716L78.4326 89.5258C77.4614 88.3179 77.1281 88.2151 73.9793 88.1519L71.1796 88.0956V72.061L72.8929 71.6754C77.456 70.6479 82.0036 68.2322 85.5999 64.9253C92.1019 58.9463 95.5171 49.8804 94.5706 41.1121C94.1272 37.0036 92.8226 33.0397 90.7711 29.5669C88.2382 25.2792 83.636 20.9655 79.2195 18.7396C74.2467 16.2333 68.2359 15.2136 62.8225 15.9576ZM64.0761 19.008C60.935 19.3869 57.9179 20.2594 55.4348 21.5072C48.1793 25.153 43.2808 31.7343 41.8071 39.8165C41.3824 42.1458 41.426 46.3628 41.8999 48.7602C42.8752 53.6959 45.0352 57.8949 48.4255 61.4458C52.3109 65.5152 56.8981 67.944 62.4882 68.8919C63.7239 69.1012 64.1687 69.2523 64.4939 69.5729L64.9118 69.9846L64.9576 79.9341C64.9908 87.1993 64.9509 90.0108 64.8092 90.3547C64.4326 91.2688 64.2198 91.3165 60.5288 91.3165H57.1396V94.509H60.4935C62.4742 94.509 63.979 94.5799 64.1688 94.6821C64.9138 95.0828 64.9954 95.5953 64.9954 99.8774V103.918H68.0039V99.8774C68.0039 95.5953 68.0855 95.0828 68.8305 94.6821C69.0203 94.5799 70.5251 94.509 72.5058 94.509H75.8596V91.3165H72.4705C68.7795 91.3165 68.5667 91.2688 68.1901 90.3547C68.0484 90.0108 68.0084 87.2027 68.0417 79.948C68.0855 70.434 68.101 69.9972 68.4072 69.6572C68.7621 69.2631 69.2309 69.1159 71.417 68.7119C76.21 67.8261 80.4865 65.5159 84.1412 61.838C89.0462 56.902 91.4601 51.0576 91.4666 44.1011C91.4693 41.1227 91.25 39.4836 90.4886 36.792C89.9128 34.7565 87.9877 30.9071 86.6626 29.1418C81.726 22.5647 74.2587 18.8114 66.3325 18.9229C65.3672 18.9365 64.3519 18.9749 64.0761 19.008ZM64.6611 22.125C59.4661 22.4782 54.4699 24.8828 50.6812 28.8529C49.0175 30.5967 47.9829 32.0523 46.9309 34.1295C45.3353 37.2798 44.6058 40.411 44.6046 44.1136C44.6028 50.0531 46.7905 55.3854 50.9467 59.5711C54.1185 62.7657 57.7857 64.7721 62.2054 65.7313C64.1244 66.1479 68.8749 66.1479 70.7939 65.7313C73.7683 65.0858 76.7918 63.7681 79.2025 62.0667C80.8179 60.9264 83.3913 58.3128 84.5034 56.6826C88.9927 50.1024 89.6795 41.6685 86.3007 34.6077C83.7215 29.2176 79.0676 25.0646 73.5128 23.1962C70.5955 22.2149 67.9852 21.899 64.6611 22.125ZM62.927 25.5433C59.3173 26.2643 56.1602 27.955 53.4205 30.634C50.949 33.0511 49.2281 35.993 48.3222 39.3499C47.9164 40.8537 47.8793 41.2556 47.8829 44.1011C47.8866 46.9357 47.9264 47.3573 48.3347 48.886C49.9253 54.8407 54.3898 59.7294 60.1482 61.8217C64.8533 63.5312 70.4922 63.1961 74.9404 60.9429C79.2068 58.7816 82.6983 54.75 84.2338 50.2112C85.0171 47.8965 85.2683 46.0605 85.1735 43.345C84.9985 38.3276 83.1489 34.1253 79.5787 30.634C76.7935 27.9103 73.6366 26.2359 69.9679 25.5363C68.3173 25.2216 64.519 25.2253 62.927 25.5433ZM58.0148 34.6786C57.1522 34.8994 56.217 35.613 55.8704 36.315C55.5757 36.9116 55.5479 37.4697 55.5005 43.7651C55.4657 48.3749 55.5085 50.7743 55.6334 51.2031C55.8645 51.9969 56.7159 52.986 57.4241 53.2836C58.1682 53.5961 62.2953 53.5961 63.0395 53.2836C63.7476 52.986 64.5991 51.9969 64.8302 51.2031C64.9551 50.7743 64.9979 48.3749 64.9631 43.7651C64.914 37.2416 64.8974 36.9321 64.5623 36.2879C64.3465 35.8727 63.9088 35.4258 63.4169 35.1188C62.6625 34.6478 62.5141 34.6196 60.5905 34.5803C59.474 34.5574 58.3148 34.6016 58.0148 34.6786ZM70.5505 34.6786C69.6879 34.8994 68.7527 35.613 68.4061 36.315C68.1114 36.9116 68.0837 37.4697 68.0362 43.7651C68.0014 48.3749 68.0442 50.7743 68.1691 51.2031C68.4002 51.9969 69.2516 52.986 69.9598 53.2836C70.7039 53.5961 74.831 53.5961 75.5752 53.2836C76.2833 52.986 77.1348 51.9969 77.3659 51.2031C77.4908 50.7743 77.5336 48.3749 77.4988 43.7651C77.4497 37.2416 77.4331 36.9321 77.098 36.2879C76.8822 35.8727 76.4445 35.4258 75.9526 35.1188C75.1983 34.6478 75.0498 34.6196 73.1262 34.5803C72.0097 34.5574 70.8505 34.6016 70.5505 34.6786ZM58.6439 50.3181H61.8196V37.8842H58.6439V50.3181ZM71.1796 50.3181H74.3554V37.8842H71.1796V50.3181Z"
              fill="#354E79"
            />
          </svg>

          <Button variant={'pink'} mt={'44px'} style={{ paddingLeft: '60px', paddingRight: '60px' }} onClick={onContinue}>
            Sign Up
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export const OtherServices = ({ region, onContinue, analytics, wmds, isLoggedInMode, history, showLearnMore }) => {
  useEffect(() => {
    try {
      analytics.track('Not qualifying WL - Other Services');
    } catch (error) {}
  }, []);

  return (
    <Flex flex={1} style={{ background: '#FDF5F2', minWidth: '100vw', minHeight: '100vh', position: 'relative', overflow: isMobile ? 'auto' : 'hidden', flexDirection: 'column' }}>
      <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }} mt={4} flexDirection={'column'}>
        <LogoSvg />
        <Text style={{ fontSize: '24px', fontWeight: 500, textAlign: 'center' }} mb={'100px'} mt={'67px'}>
          Based on your medical history, you do not qualify for our weight loss program but we have some options for you!
        </Text>
      </Flex>
      <Flex flex={1} style={{ position: 'relative', flexDirection: 'column', backgroundColor: '#1D3457' }} pb={4}>
        <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center', zIndex: 1, marginTop: '30px' }} flexDirection={'column'}>
          <Text style={{ fontSize: '30px', fontWeight: 600, textAlign: 'center', color: 'white', maxWidth: 'calc(100% * 0.75)' }} mb={'44px'}>
            How we can help
          </Text>
          <Flex flexDirection={['column', 'column', 'row']} flexWrap={'wrap'} justifyContent={'space-between'}>
            {!!region &&
              (region.level === 'full' || region.level === 'kit') && (
                <>
                  <AddonCard
                    showLearnMore
                    title="At-Home Thyroid Test Kit"
                    description="Test your TSH, free T4, Free T3 and TPO antibodies from the comfort of your own home"
                    price={`$${Constants.KIT_PRICE}`}
                    discounted={''}
                    image={palomaKit}
                    onClick={() => {
                      showLearnMore('athomekit');
                    }}
                    containerStyle={{
                      flex: 1,
                      marginLeft: '12px',
                      marginRight: '12px',
                    }}
                    hidebox={true}
                    showContinue={false}
                  />
                </>
              )}
            <AddonCard
              showLearnMore
              title="Daily Thyroid Care"
              description="Vitamin Support to support thyroid health"
              price={'$34/month'}
              discounted={''}
              image={vitaminsBottle}
              onClick={() => {
                showLearnMore('vitamins');
              }}
              containerStyle={{
                flex: 1,
                marginLeft: '12px',
                marginRight: '12px',
              }}
              hidebox={true}
              showContinue={false}
            />
          </Flex>
          {!isLoggedInMode ? (
            <Button variant={'pink'} onClick={onContinue} mt={4} style={{ padding: '6px 60px' }}>
              Sign Up
            </Button>
          ) : (
            <Button variant={'pink'} onClick={() => onContinue(true)} mt={4} style={{ padding: '6px 60px' }}>
              Go Back
            </Button>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export const TooYoung = () => {
  return (
    <Flex flex={1} style={{ background: '#FDF5F2', minWidth: '100vw', minHeight: '100vh', position: 'relative', overflow: isMobile ? 'auto' : 'hidden', flexDirection: 'column' }}>
      <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }} mt={4} flexDirection={'column'}>
        <LogoSvg />
        <Text style={{ fontSize: '24px', fontWeight: 500, textAlign: 'center' }} mb={'100px'} mt={'67px'}>
          Sorry
        </Text>
      </Flex>
      <Flex flex={1} style={{ position: 'relative', flexDirection: 'column', backgroundColor: '#1D3457' }} pb={4}>
        <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center', zIndex: 1, marginTop: '30px' }} flexDirection={'column'}>
          <Text style={{ fontSize: '30px', fontWeight: 600, textAlign: 'center', color: 'white', maxWidth: 'calc(100% * 0.75)' }} mb={'44px'}>
            Based on your age, we are unable to provide you with any medical assistance
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export const NoServices = () => {
  return (
    <Flex flex={1} style={{ background: '#FDF5F2', minWidth: '100vw', minHeight: '100vh', position: 'relative', overflow: isMobile ? 'auto' : 'hidden', flexDirection: 'column' }}>
      <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }} mt={4} flexDirection={'column'}>
        <LogoSvg />
        <Text style={{ fontSize: '24px', fontWeight: 500, textAlign: 'center' }} mb={'100px'} mt={'67px'}>
          Sorry
        </Text>
      </Flex>
      <Flex flex={1} style={{ position: 'relative', flexDirection: 'column', backgroundColor: '#1D3457' }} pb={4}>
        <Flex style={{ maxWidth: 'min(800px, 80vw)', alignSelf: 'center', justifyContent: 'center', alignItems: 'center', zIndex: 1, marginTop: '30px' }} flexDirection={'column'}>
          <Text style={{ fontSize: '30px', fontWeight: 600, textAlign: 'center', color: 'white', maxWidth: 'calc(100% * 0.75)' }} mb={'44px'}>
            No services are currently available in your state
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

const OtherServicesLoggedIn = ({ onContinue, analytics, client, session, wmds, onFailRedirectTo, history, showLearnMore, state, wmd }) => {
  useEffect(() => {
    client.mutate({
      mutation: DISQUALIFY_WEIGHTLOSS,
      refetchQueries: [{ query: CURRENT_USER }],
      awaitRefetchQueries: true,
      variables: {
        reason: wmd || '',
      },
    });
  }, []);
  const region = {
    level: session && session.eligibility && session.eligibility.status !== 'no_service' && session.eligibility.status !== 'unknown' && session.eligibility.purchase ? 'kit' : '',
  };
  if (((session.diagnoseFull && session.diagnoseFull.hasHypo) || (state['hypothyroidism'] && state['hypothyroidism'] === 'yes')) && session.eligibility && session.eligibility.consultation) {
    window.localStorage.setItem('wm-df', 'hypo');
    return <EligibleHypo onContinue={onContinue} analytics={analytics} />;
  } else if (session.gender === 'F') {
    // const age = moment().diff(moment(state['dob'], 'MM/DD/YYYY'), 'years');
    if ((session.eligibility.canBookPerimenopause) || (session.eligibility.canBookPostmenopause)) {
      window.localStorage.setItem('wm-df', 'meno');
      return <EligibleMeno onContinue={onContinue} analytics={analytics} />;
    }
  }
  return <OtherServices region={region} onContinue={onContinue} analytics={analytics} session={session} isLoggedInMode history={history} showLearnMore={showLearnMore} />;
};

export const ResultsIn = ({ state, onContinue, onChange, analytics, client, history, isLoggedInMode, region, session, showLearnMore }) => {
  let wmd = window.localStorage.getItem('wm-d');
  let wmds = window.localStorage.getItem('wm-ds');
  if (!wmd) {
    wmd = window.localStorage.getItem('wm-df');
  }
  if (wmd) {
    if (!!isLoggedInMode) {
      return (
        <OtherServicesLoggedIn
          wmd={wmd}
          state={state}
          region={region}
          onContinue={onContinue}
          analytics={analytics}
          client={client}
          wmds={wmds}
          session={session}
          history={history}
          showLearnMore={showLearnMore}
        />
      );
    }

    if (!region) return null;
    if ((region.level === 'full' || region.level === 'visit') && (state['hypothyroidism'] && state['hypothyroidism'] !== 'no')) {
      window.localStorage.setItem('wm-df', 'hypo');
      return <EligibleHypo onContinue={onContinue} analytics={analytics} />;
    } else if (state['assignedsexatbirth'] === 'F') {
      const age = moment().diff(moment(state['dob'], 'MM/DD/YYYY'), 'years');
      if ((age >= 35 && region.canBookPostMenopause) || (age < 35 && region.canBookPeriMenopause)) {
        window.localStorage.setItem('wm-df', 'meno');
        return <EligibleMeno onContinue={onContinue} analytics={analytics} />;
      }
    }
    return <OtherServices region={region} onContinue={onContinue} analytics={analytics} wmds={wmds} history={history} showLearnMore={showLearnMore} />;
  }

  return <EligibleWl state={state} onChange={onChange} onContinue={onContinue} client={client} history={history} isLoggedInMode={isLoggedInMode} analytics={analytics} />;
};

const rotateCWKF = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const rotateCCWKF = keyframes`
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(15px);
  };
  100% {
    opacity: 1;
    transform: translateX(0px);
  };
`;

const RotatingCW = styled.svg`
  animation: ${rotateCWKF} 5s linear infinite;
`;

const RotatingCCW = styled.svg`
  animation: ${rotateCCWKF} 5s linear infinite;
`;

const Option = styled(Flex)`
  opacity: 0;
  animation: 400ms cubic-bezier(0.64, 0, 0.28, 1) 0s 1 normal forwards running ${slideLeft};
  .title {
    font-size: 24px;
    margin-bottom: 32px;
    text-align: center;
  }
  .description {
    max-width: 628px;
    text-align: center;
    margin-bottom: 60px;
    font-size: 20px;
    font-weight: 500;
  }
  .description2 {
    max-width: 380px;
    text-align: center;
    margin-top: 30px;
    font-size: 18px;
  }

  @media screen and (max-width: 1000px) {
    justify-content: center;
    .title {
      font-size: 20px;
      margin-bottom: 26px;
    }
    .description {
      max-width: 90%;
      text-align: center;
      margin-bottom: 40px;
      font-size: 16px;
      font-weight: 500;
    }
    .description2 {
      max-width: 80%;
      text-align: center;
      margin-top: 20px;
      font-size: 14px;
    }
    img {
      height: 120px;
    }

    .imgLg {
      height: 200px !important;
    }
  }
`;

const MembershipBenefits = ({ onCompleted }) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onCompleted();
    }, isPreviewMode ? 300 : 3000);

    return () => clearTimeout(timeoutId);
  }, []);
  return (
    <Option>
      <Flex flexDirection={'column'} alignItems={'center'}>
        <Heading className="title" mb={4}>
          Membership Benefits
        </Heading>
        <Text className="description">
          Members enjoy <span style={{ color: '#F6A293' }}>$60 doctor visits</span>, $75 test kits, and access to private member communities
        </Text>
        <img src={DocWithBubblesLg} height={260} />
      </Flex>
    </Option>
  );
};

const CompoundedAtPharmacyPrice = ({ onCompleted }) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onCompleted();
    }, isPreviewMode ? 300 : 5000);

    return () => clearTimeout(timeoutId);
  }, []);
  return (
    <Option>
      <Flex flexDirection={'column'} alignItems={'center'}>
        <Heading className="title">Compounded GLP-1 at pharmacy pricing</Heading>
        <Text className="description">
          We don’t add any markup to compounded GLP-1 medications. You’ll pay the pharmacy directly, with <span style={{ color: '#F6A293' }}>pricing starting at just $50/month</span>.
        </Text>
        <img src={TirzepatideAd} className="imgLg" />
      </Flex>
    </Option>
  );
};

const Insurances = ({ onCompleted }) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onCompleted();
    }, isPreviewMode ? 300 : 3000);

    return () => clearTimeout(timeoutId);
  }, []);
  return (
    <Option>
      <Flex flexDirection={'column'} alignItems={'center'}>
        <Heading className="title">Want to use insurance?</Heading>
        <Text className="description">
          We accept many insurance plans, and if we’re not in-network, <span style={{ color: '#F6A293' }}>members pay just $60 per visit</span>.
        </Text>
        <img src={InsurancesPartners} height={140} />

        <Text className="description2">You will be able to check your insurance coverage when you schedule a provider visit.</Text>
      </Flex>
    </Option>
  );
};

const PatientsReport = ({ onCompleted }) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onCompleted();
    }, isPreviewMode ? 300 : 3000);

    return () => clearTimeout(timeoutId);
  }, []);
  return (
    <Option>
      <Flex flexDirection={'column'} alignItems={'center'}>
        <img src={PatientReports} height={380} />

        <Text className="description" style={{ marginTop: '30px', textTransform: 'capitalize' }}>
          92% of our thyroid patient report feeling <span style={{ color: '#F6A293' }}>better after only 3 months</span>.
        </Text>
      </Flex>
    </Option>
  );
};

const DidYouKnow = ({ onCompleted }) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onCompleted();
    }, isPreviewMode ? 300 : 3000);

    return () => clearTimeout(timeoutId);
  }, []);
  return (
    <Option>
      <Flex flexDirection={'column'} alignItems={'center'}>
        <Heading className="title">Did you know?</Heading>
        <Text className="description">Thyroid issues can slow metabolism, making weight loss harder without proper care.</Text>
        <img src={ThyroidGif} height={300} />
      </Flex>
    </Option>
  );
};

const HowItWorksContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 640px;
  max-width: 90%;
  .sectionTitle {
    font-size: 17px;
    font-weight: 500;
  }
  .sectionDescription {
    font-size: 15px;
    font-weight: 300;
  }
  @media screen and (max-width: 1000px) {
    width: 90%;
    max-width: 90%;
    .sectionTitle {
      font-size: 16px;
      font-weight: 500;
    }
    .sectionDescription {
      font-size: 14px;
      font-weight: 300;
    }
  }
`;

const HowItWorks = ({ onCompleted }) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onCompleted();
    }, isPreviewMode ? 300 : 7000);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <Option>
      <HowItWorksContainer>
        <Heading mb={4}>How it works</Heading>

        <Flex flexDirection={'column'}>
          <Flex>
            <Flex>
              <Text style={{ width: '24px', textAlign: 'left' }}>1</Text>
            </Flex>
            <Flex flexDirection={'column'} mr={'28px'} alignItems={'center'}>
              <Box
                style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  border: '5px solid #BCFFEB',
                  background: 'white',
                }}
              />
              <Flex style={{ width: '5px', background: '#344F7A' }} flex={1} />
            </Flex>
            <Flex flex={1} style={{ paddingBottom: '40px' }} flexDirection={'column'}>
              <Text className="sectionTitle">Meet online with your new weight loss specialist</Text>
              <Text className="sectionDescription">Share your history, answers some questions with an easy online visit</Text>
            </Flex>
          </Flex>

          <Flex>
            <Flex>
              <Text style={{ width: '24px', textAlign: 'left' }}>2</Text>
            </Flex>
            <Flex flexDirection={'column'} mr={'28px'} alignItems={'center'}>
              <Box
                style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  border: '5px solid #BCFFEB',
                  background: 'white',
                }}
              />
              <Flex style={{ width: '5px', background: '#344F7A' }} flex={1} />
            </Flex>
            <Flex flex={1} style={{ paddingBottom: '40px' }} flexDirection={'column'}>
              <Text className="sectionTitle">Get a blood test</Text>
              <Text className="sectionDescription">Pay cash or with your insurance</Text>
            </Flex>
          </Flex>

          <Flex>
            <Flex>
              <Text style={{ width: '24px', textAlign: 'left' }}>3</Text>
            </Flex>
            <Flex flexDirection={'column'} mr={'28px'} alignItems={'center'}>
              <Box
                style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  border: '5px solid #BCFFEB',
                  background: 'white',
                }}
              />
              <Flex style={{ width: '5px', background: '#344F7A' }} flex={1} />
            </Flex>
            <Flex flex={1} style={{ paddingBottom: '40px' }} flexDirection={'column'}>
              <Text className="sectionTitle">Get your prescription</Text>
              <Text className="sectionDescription">
                Our providers prescribe a wide range of weight loss medications, including branded GLP-1s, compounded options, and metformin, to support your weight loss journey
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </HowItWorksContainer>
    </Option>
  );
};

const ADS_SCREENS = [
  {
    screen: MembershipBenefits,
  },
  {
    screen: CompoundedAtPharmacyPrice,
  },
  {
    screen: Insurances,
  },
  {
    screen: PatientsReport,
  },
  {
    screen: DidYouKnow,
  },
  {
    screen: HowItWorks,
  },
];

const LdrIconsContainer = styled(Flex)`
  transform: scale(1);
  position: relative;
  @media screen and (max-width: 1000px) {
    transform: scale(0.5);
  }
`;

const Ldr = () => {
  return (
    <LdrIconsContainer>
      <RotatingCW width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 27.5C3 33.9978 5.58124 40.2295 10.1759 44.8241C14.7705 49.4188 21.0022 52 27.5 52C33.9978 52 40.2295 49.4188 44.8241 44.8241C49.4188 40.2295 52 33.9978 52 27.5C52 21.0022 49.4188 14.7705 44.8241 10.1759C40.2295 5.58124 33.9978 3 27.5 3"
          stroke="#354E79"
          strokeWidth="5.44444"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </RotatingCW>
      <RotatingCCW style={{ position: 'absolute', top: 11, left: 11 }} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M30.1109 16.4998C30.1109 13.8078 29.3126 11.1762 27.817 8.93786C26.3214 6.69952 24.1956 4.95495 21.7085 3.92476C19.2214 2.89457 16.4847 2.62502 13.8444 3.15021C11.2041 3.6754 8.77883 4.97173 6.87528 6.87528C4.97173 8.77883 3.6754 11.2041 3.15021 13.8444C2.62502 16.4847 2.89457 19.2214 3.92476 21.7085C4.95495 24.1956 6.69952 26.3214 8.93786 27.817C11.1762 29.3126 13.8078 30.1109 16.4998 30.1109"
          stroke="#354E79"
          strokeWidth="5.44444"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </RotatingCCW>
    </LdrIconsContainer>
  );
};

const AdsContainer = styled(Flex)`
  flex: 1;
  flex-direction: row;
  min-height: 100vh;
  min-width: 100vw;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

const LogoContainer = styled(Flex)`
  flex: 1;
  flex-direction: column;
  background: white;
  align-items: center;
  padding-top: 101px;
  padding-left: 16px;
  padding-right: 16px;
  .title {
    font-size: 24px;
    max-width: 338px;
    margin-top: 32px;
    margin-bottom: 32px;
  }
  @media screen and (max-width: 1000px) {
    padding-top: 20px;
    flex: initial;
    padding-bottom: 10px;
    .title {
      font-size: 16px;
      max-width: 300px;
      margin-top: 16px;
      margin-bottom: 16px;
    }
  }
`;

const ScreensContainer = styled(Flex)`
  flex: 1;
  justify-content: center;
  padding-top: 101px;
  padding-left: 16px;
  padding-right: 16px;
  @media screen and (max-width: 1000px) {
    padding-top: 30px;
  }
`;
const Waiter = (props) => {
  const [screenIndex, setScreenIndex] = useState(0);

  if (screenIndex < ADS_SCREENS.length) {
    const Scr = ADS_SCREENS[screenIndex].screen;
    return (
      <AdsContainer>
        <LogoContainer>
          <LogoSvg />
          <Text className="title" style={{ textAlign: 'center' }}>
            Hang tight! We’re currently verifying your eligibility for our programs.
          </Text>
          <Ldr />
        </LogoContainer>
        <ScreensContainer>
          <Scr
            key={`scr_${screenIndex}`}
            onCompleted={() => {
              // return;
              setScreenIndex((p) => p + 1);
            }}
          />
        </ScreensContainer>
      </AdsContainer>
    );
  } else {
    return <ResultsIn {...props} />;
  }
};

export const Results = withRouter(withAnalytics(withApollo(Waiter)));
